export function getSwitchAccountPath(locale: string, pathname: string) {
    const fallbackPath = `/${locale}/customer/select-account`;

    if (!pathname.startsWith(`/${locale}/customer`) || pathname === fallbackPath) {
        return fallbackPath;
    }

    return `${fallbackPath}?returnTo=${encodeURIComponent(pathname)}`;
}
